import api from "./api";
import packageJson from '../../package.json';

const login = async (phoneNumber) => await api.post('user/login', {phoneNumber})

const verify = async (phoneNumber, code) => await api.post('user/verify', {phoneNumber, code,appVersionName:packageJson.version,appVersionCode:packageJson.versionCode})

const get = async () => await api.get("user/profile")
const getLastForm = async () => await api.get("user/form")

const update = async (user) => await api.patch('user/profile', user)
const saveForm = async (form) => await api.post('user/form', form)

export default {login,verify,get,update,getLastForm,saveForm}
